import { Link, Outlet, useLocation } from "react-router-dom";
import { BrandMark, SiteHeader, type SecondaryNavItem } from "@/components/layout/SiteHeader";
import { AdFreeUpsell } from "@/components/ads/AdFreeUpsell";

const LADDER_NAV: SecondaryNavItem[] = [
  { to: "/ladder/predictor", label: "Predictor" },
  { to: "/ladder/possible-finishes", label: "Possible finishes" },
];

export function PublicShell() {
  const { pathname } = useLocation();
  const showLadderNav = pathname.startsWith("/ladder");

  return (
    <div className="min-h-screen overflow-x-hidden bg-background text-foreground">
      <SiteHeader
        secondaryLabel="Ladder navigation"
        secondaryNav={showLadderNav ? LADDER_NAV : undefined}
      />

      <main id="main-content">
        <Outlet />
      </main>

      <div className="mx-auto max-w-[1440px] px-5 pb-8 sm:px-8 lg:px-12">
        <AdFreeUpsell />
      </div>

      <footer className="border-t border-white/[0.08] bg-navy-950">
        <div className="mx-auto grid max-w-[1440px] gap-8 px-5 py-10 sm:px-8 md:grid-cols-[1fr_auto] lg:px-12">
          <div>
            <BrandMark compact />
            <p className="mt-3 max-w-md text-sm leading-6 text-white/45">
              A clearer way to follow the NRL and AFL — predict the ladder, read the round, and tip
              with your people.
            </p>
          </div>
          <div className="flex flex-wrap items-start gap-x-8 gap-y-3 text-sm font-medium text-white/50">
            <Link className="hover:text-white" to="/news">
              News
            </Link>
            <Link className="hover:text-white" to="/ladder/predictor">
              Predictor
            </Link>
            <Link className="hover:text-white" to="/ladder/possible-finishes">
              Possible finishes
            </Link>
            <Link className="hover:text-white" to="/tipping/dashboard">
              Tipping
            </Link>
            <Link className="hover:text-white" to="/profile">
              Profile
            </Link>
            <Link className="hover:text-white" to="/privacy">
              Privacy
            </Link>
          </div>
        </div>
        <div className="border-t border-white/[0.06] px-5 py-5 text-center text-xs text-white/30">
          © {new Date().getFullYear()} Tackle Four. Built for the run home.
        </div>
      </footer>
    </div>
  );
}
